/**
 * Classic Q, intermission 1: a short fuse (docs/spec/03 §2). A column of boulders stands on one
 * cell of dirt over a butterfly's ring; step off it at the right moment.
 */

import type { CaveDef } from '../types';

export const caveQ: CaveDef = {
  id: 'Q',
  name: 'SHORT FUSE',
  hint: 'One column of boulders. One butterfly. One chance.',
  intermission: true,
  colors: [2, 3, 1],
  diamondValue: 25,
  extraValue: 40,
  fill: { base: '.', items: [['r', 12], ['d', 3]] },
  levels: [
    { seed: 1701, diamonds: 8, time: 30 },
    { seed: 1702, diamonds: 9, time: 27 },
    { seed: 1703, diamonds: 10, time: 24 },
    { seed: 1704, diamonds: 11, time: 21 },
    { seed: 1705, diamonds: 12, time: 18 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWW',
    'WP..?????wrw??????XW',
    'W...d????wrw???????W',
    'W????????wrw??d????W',
    'W????????wrw???????W',
    'W???????.....???d??W',
    'W????????. ........W',
    'W?d??????.        .W',
    'W????????. ......b.W',
    'W????????.        .W',
    'W????????..........W',
    'WWWWWWWWWWWWWWWWWWWW',
  ],
};
